module.exports = __webpack_public_path__ + "img/logo_w.c43ad94a.png";